<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">User</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Profile
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <div class="pl-30 pull-left">
                  <h2>
                    Profile
                    <span><i class="ic-settings-horizontal"></i></span>
                  </h2>
                  <p>Set user profile.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="row">
            <button
              class="btn btn-default"
              type="button"
              @click="resetPassword()"
            >
              <span>Reset Password</span>
            </button>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="userpasswordmodal">
      <div class="modal-dialog modal-xs">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>Change Password</h4>
                <h6>Please fill all information below.</h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- /.modal-header -->
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <form role="form" action="#" id="user-password-form">
                    <div class="form-group">
                      <label class="required">Old Password</label>
                      <input
                        type="password"
                        name="password"
                        class="form-control"
                        v-model="changePasswordModel.oldPassword"
                        maxlength="100"
                        required
                      />
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.oldPassword"
                        v-text="validationErrors.oldPassword"
                      ></small>
                    </div>
                    <div class="form-group">
                      <label class="required">New Password</label>
                      <input
                        type="password"
                        name="password"
                        class="form-control"
                        v-model="changePasswordModel.password"
                        maxlength="100"
                        required
                      />
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.password"
                        v-text="validationErrors.password"
                      ></small>
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.oldPassword"
                        v-text="validationErrors.oldPassword"
                      ></small>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="submit"
                        class="btn btn-primary"
                        @click.prevent="changePassword()"
                      >
                        Change Password
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import identityUserService from "@/services/master/identity/identityUserService.js";

export default {
  data() {
    return {
      profile: {},
      validationErrors: {
        oldPassword: null,
        password: null,
      },
      changePasswordModel: {
        isMobile: false,
        id: "",
        changePasswordId: "",
        password: "",
        oldPassword: "",
      },
      isLoading: false,
      msg: "Please wait",
    };
  },
  async created() {
    this.profile = await this.$store.dispatch("user/getProfile");
  },
  methods: {
    resetValidations() {
      this.validationErrors.oldPassword = null;
      this.validationErrors.password = null;
    },
    resetModel() {
      this.changePasswordModel = {
        isMobile: false,
        id: "",
        changePasswordId: "",
        password: "",
        oldPassword: "",
      };
    },
    closeModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.userpasswordmodal).modal("hide");
    },
    async resetPassword() {
      this.resetModel();
      this.resetValidations();
      var item = this.profile;

      this.changePasswordModel.isMobile = false;
      this.changePasswordModel.id = item.id;
      $(this.$refs.userpasswordmodal).modal();
    },
    async changePassword() {
      try {
        this.isLoading = true;
        await identityUserService.changePassword(this.changePasswordModel);
        this.$notification.success("Password changed successfully.", {
          title: "Success",
        });
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/Profile.vue